module.exports = __webpack_public_path__ + "img/flag_gb-eaw.11fb4c3.svg";